import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { heroEnter } from '../../utils/animations';
import { HeroVideo } from './HeroVideo';

export function HeroSection() {
    return (
        <section data-testid="hero-section" className="bg-navy-900 hero-pattern overflow-hidden">
            <div className="absolute inset-0 bg-gradient-to-br from-navy-950/60 via-transparent to-navy-900/30 pointer-events-none" />

            <div className="relative max-w-7xl mx-auto px-6 lg:px-12 pt-32 pb-10">
                <motion.div {...heroEnter()} className="text-center max-w-4xl mx-auto">
                    <p className="text-gold-400 text-xs font-bold tracking-[0.3em] uppercase mb-5 font-inter">
                        For Real Estate Agents & Industry Professionals
                    </p>
                    <h1 className="font-montserrat font-black text-4xl md:text-5xl lg:text-6xl text-white leading-[1.05] mb-6 tracking-tight">
                        You Built This Business to Have a Life.{' '}
                        <span className="text-gold-400">Instead, It's Consuming It.</span>
                    </h1>
                    <p className="text-gray-300 text-lg max-w-2xl mx-auto mb-8 leading-relaxed font-inter">
                        Most agents don't have a production problem - they have a leverage problem. White Glove Hiring places high-caliber VAs and installs the systems to keep them on track, so you can stop being the bottleneck in your own business.
                    </p>
                    <div className="flex flex-wrap justify-center gap-4">
                        <Link
                            to="/how-it-works"
                            data-testid="hero-cta-primary"
                            className="bg-gold-400 text-white px-8 py-3.5 font-semibold text-sm tracking-wide rounded-sm hover:bg-gold-500 transition-colors duration-200 shadow-sm"
                        >
                            See How It Works
                        </Link>
                        <Link
                            to="/contact"
                            data-testid="hero-cta-secondary"
                            className="border border-white/60 text-white px-8 py-3.5 font-semibold text-sm tracking-wide rounded-sm hover:bg-white/10 transition-colors duration-200"
                        >
                            Book a Diagnostic Call
                        </Link>
                    </div>
                </motion.div>
            </div>

            <HeroVideo />
        </section>
    );
}
